import Vue from 'vue'
import store from './store'

function getTitle(vm) {
    const { title } = vm.$options;
    if(title) { return typeof title === 'function' ? title.call(vm) : title; }
}

Vue.mixin({
    created() {
        // let title = getTitle(this);
        // if(title) { document.title = title + ' | ' + store.getters.global.name; }
    }
});